if (!customElements.get('complementary-product-selector')) {
  class ComplementaryProductSelector extends customElements.get(
    'product-selector',
  ) {
    constructor() {
      super();

      this.recommendationsWrapper = this.closest('cart-recommendations');
      this.card = this.closest('.card-product-complementary');
    }

    onSubmitHandler(event) {
      event.preventDefault();

      this.submitButton.classList.add('disabled');

      const formData = new FormData(this.form);
      formData.append(
        'sections',
        this.cartDrawer.getSectionsToRender().map((section) => section.section),
      );
      formData.append('sections_url', window.location.pathname);

      Cart.add(formData)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          this.cartDrawer.renderContents(response, {
            expandMessageForKey: ProductSelector.getMessageKey(response),
          });
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.submitButton.classList.remove('disabled');
          this.card.classList.add('is-added');

          if (!breakpointTablet.matches) return;

          setTimeout(() => {
            this.recommendationsWrapper.slider.update();
          }, 1500);
        });
    }
  }

  customElements.define(
    'complementary-product-selector',
    ComplementaryProductSelector,
  );
}
